var React = require('react');

function Legendary (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface21536814"},[React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(92.941177%,63.137257%,1.960784%)","fillOpacity":"1"},"d":"M 1.976562 64 C 1.976562 29.75 29.75 1.976562 64 1.976562 C 98.25 1.976562 126.023438 29.75 126.023438 64 C 126.023438 98.25 98.25 126.023438 64 126.023438 C 29.75 126.023438 1.976562 98.25 1.976562 64 Z M 1.976562 64 ","key":0}),React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(100%,100%,100%)","fillOpacity":"1"},"d":"M 64 24.476562 L 76.199219 49.175781 L 103.449219 53.148438 L 83.726562 72.375 L 88.375 99.523438 L 64 86.699219 L 39.601562 99.523438 L 44.273438 72.375 L 24.550781 53.148438 L 51.800781 49.175781 Z M 64 24.476562 ","key":1})]));
}

Legendary.defaultProps = {"viewBox":"0 0 128 128","width":"128px","height":"128px"};

module.exports = Legendary;

Legendary.default = Legendary;
